<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="enviarLaudosPacsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar Laudos para o PACS</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ lista.length }} laudos selecionados para envio.

                        <div v-if="progressao || progressao === 0">
                            <hr>
                            <div>Processando...</div>
                            <div class="progress mb-3">
                                <div class="progress-bar" role="progressbar" :style="'width: ' + progressao + '%; height: 12px;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>

                            <template v-if="progressao == 100">
                                <div class="alert alert-success">Envio concluído!</div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" :disabled="enviando || iniciado" @click="enviar_laudos()">Enviar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
    data() { 
        return { 
            lista: [], 
            validate: false, 
            enviando: false, 
            progressao: null, 
            evento_subscribe: "", 
            iniciado: false,             
        };
    }, 

    methods: {
        abrir(lista) {
            this.iniciado = false; 

            this.lista = lista.filter(item => item.atendimento_procedimento 
                && item.status_laudo 
                && item.status_laudo.fl_pronto 
                && ( item.atendimento_procedimento.st_pacs == 'OK' ));

            $('#enviarLaudosPacsModal').modal('show');
        },

        enviar_laudos() { 

            this.enviando = true;
            this.iniciado = true; 

            let ids = this.lista.map(item => item.id_laudo);

            this.$util.atualizar(this, { 
                service: 'laudos', 
                func: 'enviar_laudos_pacs',
                dados: { 
                    ids: ids 
                },
                callback: () => { 
                    this.iniciar_progresso(); 
                    
                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Atenção', 
                        detail: 'Envio iniciado.',
                        life: 3000 
                    });
                }
            });

        },

        iniciar_progresso() { 

            this.evento_subscribe = "processar-envio-laudos-pacs-" + this.$store.state.user.id_usuario;
            this.progressao = 0; 

            subscribe(this.$store.state.dominio, this.evento_subscribe, 
                (retorno) => {
                    console.log('progresso', retorno);

                    if ( this.item ) { 
                        // this.editar_repasse(this.item);
                    }

                    if ( retorno.data.fim ) { 
                        unSubscribe(this.$store.state.dominio, this.evento_subscribe);
                        this.evento_subscribe = "";
                        this.enviando = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 6000
                        });

                        this.progressao = 100;

                    } else if ( retorno.data.mensagem ) { 

                        this.progressao = Math.round((retorno.data.num_notificacao / this.lista.length) * 100);

                        if ( this.progressao > 100 ) { 
                            this.progressao = 99; 
                        }

                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 3000
                        });

                    }

                }
            );

        }

    }

}
</script>